import Vue from 'vue'
Vue.directive('drag', {
  inserted: function (el, binding) {
    console.log(binding.value)
    let box = el
    let bar = document.getElementById(binding.value)
    let disX
    let disY
    bar.onmousedown = function (ev) {
      if (!event) {
        event = window.event
        // 防止IE文字选中
        bar.onselectstart = function () {
          return false
        }
      }
      let oEvent = ev || event
      oEvent.preventDefault()
      oEvent.stopPropagation()
      // 当前拖拽目标的xy
      disX = oEvent.clientX - box.offsetLeft
      disY = oEvent.clientY - box.offsetTop
      document.onmousemove = function (ev) {
        let doc = ev || event
        let l = doc.clientX - disX
        let t = doc.clientY - disY
        if (l < 0) {
          l = 0
        } else if (l > document.documentElement.clientWidth - box.offsetWidth) {
          l = document.documentElement.clientWidth - box.offsetWidth
        }
        if (t < 0) {
          t = 0
        } else if (t > document.documentElement.clientHeight - box.offsetHeight) {
          t = document.documentElement.clientHeight - box.offsetHeight
        }
        box.style.left = l + 'px'
        box.style.top = t + 'px'
        box.style.bottom = 'unset'
        box.style.right = 'unset'
      }
      document.onmouseup = function () {
        document.onmousemove = null
        document.onmouseup = null // 鼠标抬起来后，onmouseup事件本身也没意义了，所以最好清理掉
      }
      return false // 阻止默认行为，空的div在低版本ff下，第二次拖动手型会变异常
    }
  }
})




// WEBPACK FOOTER //
// ./src/directive/drag.js